<template>
    <div v-if="activeBundled" class="box_bundled_products">
        <div v-if="onLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        <label class="heade_title_bundled_product">Bought Together</label>
        <template v-for="item in bundledProducts">
            <product v-bind:class="{hideProduct: onLoading}" @OffLoding="OffLoding" :key="item.id" :id="item.id" :origin_id="item.origin_id" />
        </template>
        <div style="clear: both;"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Product from './BundledProduct/Product';
export default {
    name: "BundledProducts",
    data(){
        return {
            onLoading: true,
            onShow: true,
            activeBundled: false
        }
    },
    components: {
        Product
    },
    computed: {
        ...mapGetters(['bundledProducts'])
    },
    mounted(){

    },
    created() {
        if(this.bundledProducts.length >= 1){
          this.activeBundled = true
        }
    },
    methods: {
        OffLoding(v){
            this.onLoading = v
        }
    }
}
</script>

<style scoped>
.box_bundled_products{
    position: relative;
    width: 100%;
    border-radius: 3px;
    border: 1px solid #b6b6b61f;
    padding: 12px;
    margin: 10px 0;
    background: #F8F8F8;
}
label.heade_title_bundled_product {
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    margin-bottom: 10px !important;
    margin-left: 5px !important;
    letter-spacing: 0.5px;
    color: #bc120f;
    font-size: 16px;
}
.lds-ellipsis {
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.lds-ellipsis div {
    margin: 0 auto;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: rgb(118, 118, 118);
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

.hideProduct{
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/BundledProducts.vue